var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderShareIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8213 8C29.4213 6.84 28.3013 6 27.0013 6H15.2812L16.6013 8H29.8213Z",
    fill: "url(#paint0_linear_13210_47617)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10H16.07C15.736 10 15.424 9.834 15.238 9.554L12.426 5.336C11.868 4.5 10.934 4 9.93 4H3C1.346 4 0 5.346 0 7V25C0 26.654 1.346 28 3 28H29C30.654 28 32 26.654 32 25V13C32 11.346 30.654 10 29 10Z",
    fill: "url(#paint1_linear_13210_47617)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9193 24.25V23.0833C18.9193 22.4645 18.6734 21.871 18.2359 21.4334C17.7983 20.9958 17.2048 20.75 16.5859 20.75H11.9193C11.3004 20.75 10.7069 20.9958 10.2694 21.4334C9.83177 21.871 9.58594 22.4645 9.58594 23.0833V24.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2474 18.4167C15.5361 18.4167 16.5807 17.372 16.5807 16.0833C16.5807 14.7947 15.5361 13.75 14.2474 13.75C12.9587 13.75 11.9141 14.7947 11.9141 16.0833C11.9141 17.372 12.9587 18.4167 14.2474 18.4167Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4141 24.2503V23.0837C22.4137 22.5667 22.2416 22.0645 21.9249 21.6559C21.6081 21.2473 21.1646 20.9554 20.6641 20.8262",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3359 13.8262C18.8378 13.9547 19.2827 14.2466 19.6004 14.6559C19.9181 15.0651 20.0905 15.5685 20.0905 16.0866C20.0905 16.6047 19.9181 17.1081 19.6004 17.5173C19.2827 17.9266 18.8378 18.2185 18.3359 18.347",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13210_47617",
    x1: 22.5513,
    y1: 6,
    x2: 22.5513,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00173D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13210_47617",
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00173D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderShareIcon);
export default __webpack_public_path__ + "static/media/folderShareIcon.b2c89a4d24a64df3d59a831782bcdd69.svg";
export { ForwardRef as ReactComponent };